module.exports = __webpack_public_path__ + "img/main-menu-cow888-15.81ba2307.png";